export default __webpack_public_path__ + "static/media/icon_photo-outlined.22326a76.svg";